import React from 'react';
import PropTypes from 'prop-types';

/** Carte visuelle — contenu et handlers inchangés. */
const Card = ({ children, className = '', muted = false, pad = 'default', ...rest }) => {
  const padClass = pad === 'lg' ? ' tsk-ui-card--pad-lg' : '';
  const mutedClass = muted ? ' tsk-ui-card--muted' : '';
  return (
    <div
      className={`tsk-ui-card${mutedClass}${padClass}${className ? ` ${className}` : ''}`}
      {...rest}
    >
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  muted: PropTypes.bool,
  pad: PropTypes.oneOf(['default', 'lg']),
};

export default Card;
